var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mb-12",attrs:{"color":"grey lighten-1","height":"200px"}}),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.finish}},[_vm._v(" "+_vm._s(_vm.$t('finish'))+" ")]),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.back}},[_vm._v(" "+_vm._s(_vm.$t('back'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }